import Request from './request'

async function fetch () {
  return Request('get', 'api/take-templates/index')
}

async function del(id) {// 删除数据
    return Request('get', "api/take-templates/delete/" + id);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id)
      return Request('patch', "api/take-templates/edit", Object.assign(data, {id}));
    else
        return Request('post', "api/take-templates/add", data);
}

export default {
  fetch,
  del,
  save,
}